<template>
  <div id="T0b">
    <div class="wrapper">
      <kg-header />
      <div id="content">
        <div class="inner_static">
          <h1 id="logo" class="kagull_logo_h1">
            <strong>カグル.</strong>
          </h1>
          <div id="bx_membership">
            <h2 id="tit_membership">本アプリをご利用頂くには<br>メンバー登録が必要です。</h2>
            <p class="lead">
              メンバー登録（無料）していただくことで、投稿をはじめとし、「カグル」の機能全てがご利用いただけるようになりますので、是非ご利用ください。
            </p>
            <ul class="lst_btn">
              <li>
                <a @click="btnRegistClick()">登録する</a>
              </li>
              <li>
                <a class="btn_a" @click="btnAboutClick()">カグルとは？</a>
              </li>
            </ul>
            <section class="sns_account">
              <h6 class="tit">ソーシャルアカウントでログイン</h6>
              <ul class="lst_sns">
                <li>
                  <a class="btn_facebook">Facebook</a>
                </li>
                <li>
                  <a class="btn_twitter">Twitter</a>
                </li>
              </ul>
            </section>
          </div>
        </div>
      </div>
      <kg-footer :toContactEventFlg="false"/>
    </div>
  </div>
</template>

<script>
// import * as App from '../../utils/App'
// import {KG_STORAGE_KEY} from '../../constants/App'
// Module
import Header from '../components/login/LoginHeader'
import Footer from '../components/login/LoginFooter'

export default {
  name: 'Login',
  components: {
    'kg-header': Header,
    'kg-footer': Footer
  },
  methods: {
    btnRegistClick: function () {
      this.$router.push('/kagull/user/registinput')
    },
    btnAboutClick: function () {
      this.$router.push('/kagull/about/0')
    }
  }
  // data () {
  //   return {
  //     form: {
  //       loginId: '',
  //       password: ''
  //     },
  //     /** 共通エラーメッセージ */
  //     errorMessage: { text: '' },
  //     /** 項目別エラーメッセージ */
  //     fieldErrorMessages: {
  //       loginId: '',
  //       password: ''
  //     }
  //   }
  // },
//   created () {
//     App.removeLocalStorage(KG_STORAGE_KEY.USER_INFO)
//   }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/addition.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/kagull/pages/RegistUserTop.vue